import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import QuestionThumbnail from './components/questionsThumbnail';
import { faList, faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import CustomToast from '../../../../../../components/Toast';
import ThumbnailSkeleton from '../../../../../../components/SkeletonLoader/ThumbnailSkeleton';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faClipboardList } from '@fortawesome/pro-light-svg-icons';
import Model from '../../../../../../../src/components/Modal/index';

const QuestionsList = (props) => {
  const goToQuestionIdRef = useRef();
  const randomQuestionsRef = useRef();
  const [goToCastleIdErrorMessage, setGoToCastleIdErrorMessage] = useState('');
  const [openQuestionClipBoardModel, setOpenQuestionClipBoardModel] = useState(false);

  useEffect(() => {
    setGoToCastleIdErrorMessage('');
  }, [props.questionsList]);

  const handleSelectAllQuestions = (selectAll) => {

    if (selectAll) {
      if (props.selectedQuestions.length >= 100) {
        CustomToast('You have already reached the maximum number of questions', 'error');
        return;
      }

      var numberOfQuestionsToSelect = props.questionsList.filter(q => !q.isSelected && q.blockedText === null).length + props.selectedQuestions.length <= 100 ? props.questionsList.filter(q => !q.isSelected && q.blockedText === null).length : 100 - props.selectedQuestions.length;

      if (numberOfQuestionsToSelect < props.questionsList.filter(q => !q.isSelected && q.blockedText === null).length) CustomToast(`Maximum number of questions reached.  ${numberOfQuestionsToSelect} question${numberOfQuestionsToSelect == 1 ? ' has' : 's have'} been selected.`, 'warning');
      var tempQuestionList = [...props.questionsList];
      var tempSelectedQuestions = [...props.selectedQuestions];

      for (var i = 0; i < tempQuestionList.length; i++) {
        if (numberOfQuestionsToSelect == 0) break;

        if(tempQuestionList[i].blockedText === null && tempSelectedQuestions.find(q => q.questionId === tempQuestionList[i].questionId) === undefined)
        {
          tempQuestionList[i].isSelected = true;
          tempSelectedQuestions.push(tempQuestionList[i]);
          numberOfQuestionsToSelect--;
        }
      }

      props.setSelectedQuestions(tempSelectedQuestions);
      props.setQuestionsList(tempQuestionList);
    } else {
      props.setSelectedQuestions(props.selectedQuestions.filter(q => !props.questionsList.some(ql => `${q.questionType}${q.questionId}` == `${ql.questionType}${ql.questionId}`)));
      props.setQuestionsList(props.questionsList.map((question) => ({ ...question, isSelected: false })));
    }
  };

  const handleGoToQuestionIdChange = (e) => {
    if (e.target.value.length > 0) {
      e.target.value = e.target.value.replace(/\D/g, '');
    } else{
      setGoToCastleIdErrorMessage('');
    }
  };

  const handleGoToQuestionId = () => {
    if (props.questionsList.length == 1 && goToQuestionIdRef.current.value == props.questionsList[0].questionId) return;
    if (props.questionsList.length == 1 && props.questionsCount == 1) return;

    if (goToQuestionIdRef.current.value.length <= 0 && props.questionsList.length > 1) return;

    if (goToQuestionIdRef.current.value.length <= 0 && props.questionsList.length == 1) {
      props.getPageCastleQuestionsCall({ pageNumber: props.selectedPage, pageSize: props.questionsPerPage }).then((results) => { props.MapSearchResults(results); });
      props.setSelectedPage(props.selectedPage);
      return;
    }

    if (!/^\d+$/.test(goToQuestionIdRef.current.value) || goToQuestionIdRef.current.value > 2147483647) {
      setGoToCastleIdErrorMessage('Invalid Question ID');
      return;
    }

    if (props.questionsList.filter(q => q.questionId == goToQuestionIdRef.current.value).length >= 1) {
      props.setQuestionsList(props.questionsList.filter(q => q.questionId == goToQuestionIdRef.current.value));
    } 
    else {
      props.goToCastleQuestionCall({ questionId: goToQuestionIdRef.current.value, pageSize: props.questionsPerPage }).then((results) => {
        if (results?.error?.data?.errorMessage) {
          setGoToCastleIdErrorMessage(results.error.data.errorMessage);
          return;
        }
        setGoToCastleIdErrorMessage('');
        props.MapSearchResults(results);
      });
    }
  };

  const handleRandomlySelectQuestions = async () => {
    if (!randomQuestionsRef.current?.value) return;

    if (props.selectedQuestions.length == props.questionsCount) {
      CustomToast('All questions have already been selected', 'warning');
      return;
    }
    var response = await props.selectRandomQuestionsCall({ alreadySelectedQuestions: props.selectedQuestions.map(q => q.questionId), questionCount: randomQuestionsRef.current.value });

    if (response.error) {
      CustomToast('Could not get questions', 'error');
      return;
    }

    if (Number(randomQuestionsRef.current.value) + props.selectedQuestions.length > 100) {
      CustomToast(`Maximum number of questions reached.  ${response.data.length} question${response.data.length == 1 ? ' has' : 's have'} been selected.`, 'warning');
    } else if (response.data.length < randomQuestionsRef.current.value) {
      CustomToast(`All remaining questions have been selected. ${response.data.length} question${response.data.length == 1 ? ' has' : 's have'} been selected.`, 'warning');
    }

    props.setSelectedQuestions(props.selectedQuestions.concat(response.data.map((question) => ({ ...question, isSelected: true }))));
    props.setQuestionsList(props.questionsList.map((question) => ({ ...question, isSelected: question.isSelected || response.data.some(q => `${q.questionType}${q.questionId}` == `${question.questionType}${question.questionId}`) })));

    setOpenQuestionClipBoardModel(true);
  };

  const handleSelectRandomQuestionChange = (e) => {
    if (e.target.value.length > 0) {
      e.target.value = e.target.value.replace(/\D/g, '');
    }

    if (e.target.value > 100) {
      e.target.value = 100;
    }
  };

  return (
    <div className='d-flex flex-column whiteCard w-100'>
      <div className='d-flex flex-row justify-content-between'>
        <div className='d-flex flex-row gap-2 align-items-center'>
          <h1>Questions that match your search ({props.questionsCount})</h1>
          <OverlayTrigger
            key="image-overlay"
            placement="right"
            overlay={
              <Tooltip className="image-info-tooltip">
                <div>
                  <p><strong>{'What do the levels mean?'}</strong></p>
                        “A” = Primary Basic<br/>
                        “B” = Primary Intermediate<br/>
                        “C” = Primary Advanced<br/>
                        “D” = Elementary Basic<br/>
                        “E” = Elementary Intermediate<br/>
                        “F” = Elementary Advanced<br/>
                        “G” = Middle Basic<br/>
                        “H” = Middle Intermediate<br/>
                        “I” = Middle Advanced<br/>
                        “J” = High School Basic<br/>
                        “K” = High School Intermediate<br/>
                        “L” = High School Advanced<br/>
                        “M” = AP Level
                </div>
              </Tooltip>
            }>
            <FontAwesomeIcon icon={faQuestionCircle} className="pb-2 clr-fa-circle-question" />
          </OverlayTrigger>
        </div>
        <div className={`d-flex flex-row align-items-center ${props.questionsList.every(q => q.blockedText) && 'd-none'}`} style={{ color: (props.questionsCount > 0 ? '#F7931E' : '#F7BF7E'), fontSize: '14px', cursor: (props.questionsCount > 0 ? 'pointer' : 'default') }} onClick={() => handleSelectAllQuestions(!(props.questionsList.filter(q=>q.isSelected || q.blockedText!=null).length == props.questionsList.length))}>
          <FontAwesomeIcon color={(props.questionsCount > 0 ? '#F7931E' : '#F7BF7E')} style={{ fontSize: '16px', marginRight: '5px' }} icon={faList} />
          <span>{`${(props.questionsList.every(q => q.isSelected) || (props.questionsList.filter(q => q.isSelected || q.blockedText).length === 
                props.questionsList.length)) && props.questionsCount > 0 ? 'Unselect' : 'Select'} all questions on page`}
          </span>
        </div>
      </div>
      <Model
        isOpen={openQuestionClipBoardModel}
        onClose={() => setOpenQuestionClipBoardModel(false)}
        contentWidth="700px"
        titleName='Randomly selected questions have been added'>
        <div className='text-center'>
          Question have been added to your clipboard to review.You can view <br/>your clipboard in the toolbar at the bottom of this screen
        </div>
        <div className='w-100 d-flex justify-content-center mt-3'>
          <div className='selectedStudentsClipboard'><FontAwesomeIcon icon={faClipboardList} /></div>
        </div>
      </Model>
      {props.isError && <button style={{ color: '#F84646', fontSize: '1.15rem', border: 'none', background: 'none' }} onClick={() => props.handleRetrySearch()}>There was an error getting the data. Click to try again</button>}

      {!props.isError && <>
        <div className='goToQuestionRow'>
          <div className='d-flex flex-row align-items-center text-nowrap gap-2'>
            <div className='fw-semibold'>Randomly select questions (Max: 100)</div>
            <Form.Control type='text' className='mx-3' style={{ width: '15%' }} disabled={props.isGettingRandomQuestions || props.questionsCount == 0} ref={randomQuestionsRef} defaultValue='10' onChange={(e) => handleSelectRandomQuestionChange(e)} maxLength={3} />

            <div>
              <Button variant='castleWhite' className='btn-width' onClick={() => handleRandomlySelectQuestions()}>Select</Button>
            </div>
            {props.openQuestionsList &&
              <div>
                <Button variant='castleRed' className='btn-width' onClick={() => { props.setOpenQuestionsList(false); props.setQuestionsList([]); }}>Back</Button>
              </div>
            }
          </div>
          <div className='d-flex flex-row text-nowrap align-items-center justify-content-end'>
            <Form.Control type='text' placeholder='Go to Question ID' style={{ width: '90%', marginRight: '1em' }} ref={goToQuestionIdRef}
              onChange={(e) => handleGoToQuestionIdChange(e)}
              onKeyUp={(e) => { if (e.key == 'Enter') handleGoToQuestionId(); }}
              onBlur={() => handleGoToQuestionId()}
              disabled={props.questionsCount == 0} />
            <span style={{ color: '#F84646' }}>{goToCastleIdErrorMessage}</span>
          </div>
        </div>

        {props.questionsCount > 0 && !props.isSearching ?
          <div className='questionsGrid'>
            {props.questionsList.map((question) => {
              return (<QuestionThumbnail key={`${question.questionSource}${question.questionId}`}
                questionDetails={question}
                defaultChecked={props.selectedQuestions.includes(question)}
                selectedQuestions={props.selectedQuestions}
                setSelectedQuestions={props.setSelectedQuestions}
                setDateBasedKey={props.setDateBasedKey}
              />);
            })}
          </div>
          :
          props.questionsCount == 0 && !props.isSearching ?
            <div className='noResultsContainer'>
              <div className='noResultsBox'>
                <div className='noResultsIconBox mb-4'>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                <div className='fw-500' style={{ color: '#A4A4A4' }}>No questions were found matching your filter(s).  Please try another search.</div>
              </div>
            </div>
            :
            <>
              <ThumbnailSkeleton
                arrayLength={4}
                rowCount={2}
                className={'questionsGrid'}
                skeletonClassName={'dummy-thumbnail'}
                skeletonContainerClassName={'dummy-thumbnail m-2 mb-3'}
              />
            </>
        }
      </>
      }
    </div>
  );
};

QuestionsList.propTypes = {
  questionsCount: PropTypes.number,
  questionsList: PropTypes.array,
  setQuestionsList: PropTypes.func,
  selectedQuestions: PropTypes.array,
  setSelectedQuestions: PropTypes.func,
  isError: PropTypes.bool,
  isSearching: PropTypes.bool,
  handleRetrySearch: PropTypes.func,
  questionsPerPage: PropTypes.number,
  isGettingRandomQuestions: PropTypes.bool,
  getPageCastleQuestionsCall: PropTypes.func,
  selectedPage: PropTypes.number,
  setSelectedPage: PropTypes.func,
  goToCastleQuestionCall: PropTypes.func,
  MapSearchResults: PropTypes.func,
  selectRandomQuestionsCall: PropTypes.func,
  openQuestionsList: PropTypes.bool,
  setOpenQuestionsList: PropTypes.func,
  setDateBasedKey: PropTypes.func,
  selectedAssignmentName: PropTypes.string,
  originalQuestionsList: PropTypes.array
};

export default QuestionsList;
